import { useNavigate } from "react-router-dom";
import { Button } from "../../../src/components/ui/button";
import React from "react";

export default function AlternaHeroSection() {
  const nav = useNavigate();
  return (
    <div className="w-screen relative">
      <img
        src="./alterna-banner.jpeg"
        alt="rouh-el-rouh"
        className="size-full lg:block hidden"
      />
      <img
        src="./alterna-mobile.jpeg"
        alt="rouh-el-rouh"
        className="size-full block lg:hidden"
      />
      <div className="lg:left-20 left-14 w-fit p-5 text-neutral-900 absolute lg:top-[400px] top-2/3 flex gap-2 flex-col lg:justify-start justify-center lg:items-start items-center">
        <h2 className="lg:text-left text-center text-2xl sm:text-4xl w-full italic ">
          ALTERNA HAIRCARE
        </h2>
        <span className="font-bold sm:text-md text-sm">
          ELEVATE YOUR HAIR ROUTINE
        </span>
        <Button
          onClick={() => nav("/shop/category/502/alterna")}
          className="sm:mt-4 mt-1 rounded-none w-44 text-[12px] sm:text-[14px] h-full dark:bg-neutral-800 dark:text-neutral-100 hover:dark:bg-neutral-700"
        >
          SHOP NOW
        </Button>
      </div>
    </div>
  );
}
